export const StatusToColorClassMap = new Map<string, string>([
  // PLAT-4318 — **retained through the draft-entity pivot, with a different source.** This
  // key no longer colours a wire status value (no entity's status field can hold a draft
  // token any more); it colours the CLIENT-SYNTHESIZED `DRAFT_ROW_LABEL` that each list
  // page's merged draft rows carry. StatusColorPipe does `get(value?.toLowerCase()) || ''`,
  // so one key serves all three flows. Without it the badge renders with no colour class at
  // all, silently, because of the `|| ''` fallback.
  // 'paused' is the palette's neutral grey (_chip.scss defines success/primary/pending/
  // error/discovery/paused only) and is the right register for work not yet submitted.
  ['draft', 'paused'],
  ['new', 'primary'],
  ['pending connection', 'pending'],
  ['pending technical details', 'pending'],
  ['pending approval', 'pending'],
  ['under discovery', 'pending'],
  ['pending_approval', 'pending'],
  ['under_discover', 'pending'],
  ['connected', 'success'],
  ['success', 'success'],
  ['approved', 'success'],
  ['pending next run', 'success'],
  ['pending schema approval', 'error'],
  ['connection failed', 'error'],
  ['failure', 'error'],
  ['pending connection', 'discovery'],
  ['approvedconnector', 'discovery'],
  ['automated', 'discovery'],
  ['discovery', 'discovery'],
  ['deleted', 'discovery'],
  ['needs schema approval', 'discovery'],
  ['queued', 'discovery'],
  ['running', 'discovery'],
  ['pausing', 'discovery'],
  ['paused', 'paused'],
  ['resuming', 'discovery'],
  // ZenDesk issues
  ['new', 'primary'],
  ['open', 'primary'],
  ['pending', 'pending'],
  ['on-hold', 'pending'],
  ['closed', 'success'],
  ['solved', 'success'],
  // Customer Type
  ['universal', 'universal'],
  // Vpn cards
  ['in_progress', 'pending'],
  ['under_config', 'discovery'],
  ['connected', 'success'],
  ['submitted', 'discovery'],
  // Pipelines
  ['approvedpipeline', 'discovery'],
  ['published', 'success'],
  ['errors', 'error'],
  //Process Issues
  ['pending_schema_approval', 'error'],
  ['pending_approval', 'pending'],
  ['need_schema_approval', 'discovery'],
  ['pending_schema_approval', 'error'],
  ['pending_technical_details', 'pending'],
  ['pending_next_run', 'success'],
  ['pending_connection', 'discovery'],
  ['connection_failed', 'error'],
  // Projects
  ['in process', 'pending'],
  ['on hold', 'discovery'],
  ['done', 'success'],
  ['withdrawn', 'universal'],
  // Discovery
  ['update catalog', 'discovery'],
  ['update_catalog', 'discovery'],
  ['catalogued', 'pending'],
  ['discovery incomplete', 'pending'],
  ['catalog incomplete', 'pending'],
  ['discovery_incomplete', 'pending'],
  ['catalog_incomplete', 'pending'],
]);
